<template>
    <div class="form-group has-effect" :class="{ 'is-invalid': invalid }">
        <div class="has-effect-input">
            <select
                class="form-control custom-select"
                :class="[
                    { 'has-content': selectedOption },
                    { 'is-invalid': invalid }
                ]"
                v-model="selectedLocal"
                :placeholder="text"
                :required="required"
            >
                <option
                    v-if="text && firstOption"
                    disabled
                    value=""
                    :selected="selectedLocal === ('' || null)"
                    >{{ text }}</option
                >
                <option
                    v-for="(opt, idx) in options"
                    :key="idx"
                    :value="opt.value || opt"
                    >{{ opt.label || opt }}</option
                >
            </select>
            <span class="dropdown-select-label form-label">{{ text }}</span>
        </div>
        <div v-if="invalid" class="invalid-feedback">{{ invalid }}</div>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: false
        },
        options: {
            type: Array,
            required: true
        },
        selectedOption: {
            type: [String, Number],
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
        invalid: {
            type: String,
            required: false
        },
        firstOption: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        selectedLocal: {
            get() {
                return this.selectedOption ? this.selectedOption : ''
            },
            set(value) {
                this.$emit('onChange', value)
            }
        }
    }
}
</script>
